module.exports = __webpack_public_path__ + "media/images/aloe/icons/checkout/bank-1dc0ddf529f60f1eea9bfda7edd96239.svg";